import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Share = forwardRef<SVGSVGElement, SvgIconProps>(
  function Share(props, ref) {
    return (
      <SvgIcon ref={ref} {...props} viewBox="0 0 40 40">
        <circle cx="20" cy="20" fill="#5A98B1" r="20" />
        <path
          d="M5.52941176,15.5291474 C6.48070588,15.5291474 7.34282353,15.1513631 7.97694118,14.5392138 L14.9705882,18.0356301 C14.9531249,18.178101 14.9411765,18.3224214 14.9411765,18.4704055 C14.9411765,20.4199653 16.5211294,22 18.4705882,22 C20.4200471,22 22,20.4199653 22,18.4704055 C22,16.5208458 20.4200471,14.9408111 18.4705882,14.9408111 C17.5192941,14.9408111 16.6571765,15.319513 16.0230588,15.9316623 L9.02941176,12.4343048 C9.04687506,12.2918339 9.05882353,12.1475135 9.05882353,11.9995294 C9.05882353,11.8515453 9.04687506,11.7072319 9.02941176,11.5647539 L16.0230588,8.06833766 C16.6581647,8.68051052 17.5193882,9.05918895 18.4705882,9.05918895 C20.4200471,9.05918895 22,7.47915422 22,5.52959447 C22,3.58003473 20.4200471,2 18.4705882,2 C16.5211294,2 14.9411765,3.58003473 14.9411765,5.52959447 C14.9411765,5.67758096 14.9531249,5.82189196 14.9705882,5.96436992 L7.97694118,9.45984498 C7.34275294,8.84767211 6.48061176,8.46991138 5.52941176,8.46991138 C3.57995294,8.46991138 2,10.0499461 2,11.9995059 C2,13.9490656 3.57995294,15.5291003 5.52941176,15.5291003 L5.52941176,15.5291474 Z"
          fill="#FFFFFF"
          transform="translate(6.5, 8.5)"
        />
      </SvgIcon>
    )
  },
)

export default Share
